import { setContext } from '@apollo/client/link/context';
import { AnalyticsApplication, getXLandrAnalyticsV2 } from '@landr/core';
import { auth } from '@landr/root-app/auth';
import { SamplesLanguages } from 'types/enums/languages';
import { i18n } from 'utils/setupTranslations';
import { v4 as uuidv4 } from 'uuid';
import { featureFlagService } from '@landr/root-app/feature-flags';
import { DeviceType } from '@landr/react-core';
import { getAnalyticsPlatformName } from 'helpers/getAnalyticsPlatformName';

const API_LANGUAGES: { [k in SamplesLanguages]: string } = {
    [SamplesLanguages.EN]: 'en-US',
    [SamplesLanguages.FR]: SamplesLanguages.FR,
    [SamplesLanguages.ES]: SamplesLanguages.ES,
};

export const contextLink = (deviceType: DeviceType) =>
    setContext(async (_, prevContext) => {
        const { headers: previousHeaders } = prevContext;

        const token = await auth.getToken();

        const authorization = token
            ? { authorization: `Bearer ${token}` }
            : undefined;

        return {
            ...prevContext,
            headers: {
                ...previousHeaders,
                'X-LANDR-ANALYTICS': JSON.stringify(
                    getXLandrAnalyticsV2(AnalyticsApplication.Samples, {
                        overridePlatformName:
                            // getXLandrAnalyticsV2 do not support Samples plugin
                            getAnalyticsPlatformName(deviceType),
                    }),
                ),
                'X-API-Languages':
                    API_LANGUAGES[i18n.locale as SamplesLanguages],
                // TODO: CORE-16879 use feature flags from @landr/mfe
                'X-LANDR-FEATUREFLAGS': JSON.stringify(
                    featureFlagService.get(),
                ),
                'X-CorrelationId': uuidv4(),
                ...authorization,
            },
        };
    });
